export enum SecretTypeEnum {
  AGENT = 'AGENT',
  EVALS = 'EVALS',
  DATA_PLATFORM = 'DATA_PLATFORM'
}

export type AgentMapping = {
  agentId: string;
  envVarName: string;
};

/**
 * Shape returned by GET /v3/secrets (list endpoint).
 * Does NOT include timestamps or addedByUserId — those are only in the detail DTO.
 */
export type SecretListItem = {
  id: string;
  name: string;
  type: SecretTypeEnum;
  global: boolean;
  globalEnvVarName: string | null;
  agentMappings: AgentMapping[];
  description?: string;
  updatedAt?: string;
};

/**
 * Full secret detail returned by GET /v3/secrets/{id}, POST create, PATCH update.
 * Includes timestamps and user info.
 */
export type SecretDetail = SecretListItem & {
  addedByUserId: string;
  createdAt: string;
  updatedAt: string;
};

/**
 * Secret with decrypted value — returned by GET /v3/secrets/{id} and POST /v3/secrets/bulk.
 */
export type SecretWithValue = SecretDetail & {
  value: string;
};

// --- API response envelopes (aidp-core wraps all responses in { data, error }) ---

export type ApiEnvelope<T> = {
  data: T;
  error: { message: string } | null;
};

export type GetSecretsRes = ApiEnvelope<{
  secrets: SecretListItem[];
}>;

export type GetSecretRes = ApiEnvelope<SecretWithValue>;

export type CreateSecretRes = ApiEnvelope<SecretDetail>;

export type UpdateSecretRes = ApiEnvelope<SecretDetail>;

// --- Request DTOs ---

export type CreateSecretReq = {
  name: string;
  value: string;
  userId: string;
  type?: SecretTypeEnum;
  description?: string;
  global?: boolean;
  globalEnvVarName?: string;
  envVarName?: string;
  agentIds?: string[];
};

export type UpdateSecretReq = {
  value: string;
  userId: string;
  name?: string;
  description?: string;
  envVarName?: string;
  agentIds?: string[];
};

export type UpdateSecretGlobalReq = {
  global: boolean;
  globalEnvVarName?: string;
  userId: string;
};

export type ValidateSecretRes = ApiEnvelope<{
  valid: boolean;
  errors: Array<{
    field: string | null;
    message: string;
    collisions?: Array<{
      agentId: string;
      agentName: string | null;
      envVarName: string;
      existingSecret: string;
    }>;
  }>;
}>;
